import { Link } from "react-router-dom";
import { smoothScrollTo } from "../utils/smoothScroll";

const Footer = () => {
  return (
    <footer className="relative bg-[#0c1aa6] border-t border-white/10">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid opacity-10" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">

          {/* Brand Column */}
          <div className="lg:col-span-1">
            {/* Logo */}
            <a href="/" className="flex items-center gap-2 mb-6">
              <svg className="h-8 w-8 text-white" viewBox="0 0 174 175" fill="currentColor">
                <path d="M86.36,0l.33,73.88,52.33-51.84,14.09,14.09-52,52.01.33.65h67.24v19.44h-68.05l52.14,52.06-14.39,14.38-44.89-44.23c-10.73-11.35,4.46-43.07-14.64-48.22-12.79-3.44-29.48,3.88-39.63-6.71L0,36.29l14.22-14.23,52.38,51.82V0h19.77Z"/>
                <path d="M68.91,144.75c-.71-13.96-1.42-27.92-2.14-41.88-13.21-.38-26.41-.76-39.62-1.15,2.78-3.39,5.57-6.78,8.35-10.17,10.79.17,21.57.33,32.36.5.78.08,4.51.57,7.22,3.86,2.21,2.69,2.41,5.65,2.43,6.59.31,10.73.62,21.45.93,32.18-3.18,3.36-6.35,6.72-9.53,10.08Z"/>
              </svg>
              <span className="text-white font-semibold text-xl">Arkspace</span>
            </a>

            <p className="text-[#c1d5ed] text-sm leading-relaxed mb-6 max-w-xs">
              Arquitetos de soluções de IA. Transformamos o potencial da inteligência artificial em resultado real para seu negócio.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/company/arkspaceai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-white/10 border border-white/10 flex items-center justify-center text-[#c1d5ed] hover:text-white hover:border-white/30 transition-all"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/arkspace.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-white/10 border border-white/10 flex items-center justify-center text-[#c1d5ed] hover:text-white hover:border-white/30 transition-all"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-white font-medium mb-6">Navegação</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => smoothScrollTo('labs')}
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  Labs
                </button>
              </li>
              <li>
                <button
                  onClick={() => smoothScrollTo('go')}
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  Go
                </button>
              </li>
              <li>
                <button
                  onClick={() => smoothScrollTo('about')}
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  Sobre nós
                </button>
              </li>
              <li>
                <button
                  onClick={() => smoothScrollTo('contact')}
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-white font-medium mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contato@arkspace.ai"
                  className="text-sm text-[#c1d5ed] hover:text-white transition-colors"
                >
                  contato@arkspace.ai
                </a>
              </li>
            </ul>
          </div>

          {/* Partners Column */}
          <div>
            <h4 className="text-white font-medium mb-6">Parceiros</h4>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.squadra.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-70 hover:opacity-100 transition-all"
              >
                <img
                  src="assets/images/footer/brands/squadra-logo-white.png"
                  alt="Squadra"
                  className="h-6 w-auto"
                />
              </a>
              <a
                href="https://readyforproduction.dev/"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-70 hover:opacity-100 transition-all"
              >
                <img
                  src="assets/images/footer/brands/ready-for-production.png"
                  alt="Ready for Production"
                  className="h-6 w-auto"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#c1d5ed]">
              © {new Date().getFullYear()} ArkSpace Consultoria e Desenvolvimento de Software LTDA.
            </p>
            <p className="text-xs text-[#c1d5ed]">
              CNPJ: 51.535.723/0001-26
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
